/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_Error_ExpiredInputs */



/**
* | output |
* | --- |
* | "This activation code has expired. Generate a new one in the web app under Help → Offline Activation." |
*
* @param {License_Error_ExpiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_error_expired = /** @type {((inputs?: License_Error_ExpiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Error_ExpiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce code d'activation a expiré. Générez-en un nouveau dans l'application web via Aide → Activation hors ligne.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Aktivierungscode ist abgelaufen. Erzeugen Sie in der Web-App unter Hilfe → Offline-Aktivierung einen neuen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo codice di attivazione è scaduto. Generane uno nuovo nell'app web da Aiuto → Attivazione offline.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Срок действия кода истёк. Создайте новый в веб-приложении: Справка → Офлайн-активация.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este código de activación ha caducado. Genera uno nuevo en la aplicación web en Ayuda → Activación sin conexión.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("此激活码已过期。请在网页版的“帮助 → 离线激活”中生成新代码。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このアクティベーションコードは期限切れです。Web アプリの [ヘルプ] → [オフライン アクティベーション] で新しいコードを生成してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह सक्रियण कोड समाप्त हो गया है। वेब ऐप में Help → Offline Activation में नया कोड बनाएँ।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Este código de ativação expirou. Gere um novo na aplicação web em Ajuda → Ativação offline.")
	return /** @type {LocalizedString} */ ("This activation code has expired. Generate a new one in the web app under Help → Offline Activation.")
});